export default __webpack_public_path__ + "static/igel-638d92078c26de82e89e12401ae67d30.jpg";